/* eslint-disable react/no-array-index-key */
import React from 'react';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useSearchCommonPageData } from '@/app/components/search/searchCommonPageProvider.tsx';
import Stars from '@/app/common/components/Stars';
import { Badge } from './styled';
import { handleDeleteBadge } from '../utils';
import { getPriceLabel } from '../../Filters/HorizontalFilters/Pill/utils';
import { getSearchParamsClient } from '../../../common/getSearchParams';
import type { Localization } from '../../../common/Localization';
import type { DynamicFiltersResponse } from '../../../utils/api/dynamicFiltersResponseTypes';

export const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10.0001 1.66669C5.39175 1.66669 1.66675 5.39169 1.66675 10C1.66675 14.6084 5.39175 18.3334 10.0001 18.3334C14.6084 18.3334 18.3334 14.6084 18.3334 10C18.3334 5.39169 14.6084 1.66669 10.0001 1.66669ZM14.1667 12.9917L12.9917 14.1667L10.0001 11.175L7.00841 14.1667L5.83342 12.9917L8.82508 10L5.83342 7.00835L7.00841 5.83335L10.0001 8.82502L12.9917 5.83335L14.1667 7.00835L11.1751 10L14.1667 12.9917Z" />
  </svg>
);

const FormattedText = ({
  value,
  name,
  text,
  localization,
  searchParams,
  dynamicFiltersResponse,
}: {
  value: string;
  name: URLParameters;
  text?: string;
  localization: Localization;
  searchParams: SearchParams;
  dynamicFiltersResponse?: DynamicFiltersResponse;
}) => {
  const { t } = useTranslation();
  switch (name) {
    case URLParameters.STARS:
      return <Stars stars={parseInt(value, 10)} />;
    case URLParameters.PRICE:
      return getPriceLabel({ searchParams, localization, t, dynamicFiltersResponse });
    default:
      return text;
  }
};

const Badges = ({
  controls,
  dynamicFiltersResponse,
}: {
  controls: {
    name: URLParameters;
    text?: string;
    value?: string;
  }[];
  dynamicFiltersResponse?: DynamicFiltersResponse;
}) => {
  const { searchParams: searchParamsServer, localization } = usePageWrapperData();
  const { handleFiltersChanged } = useSearchCommonPageData();
  const searchParams = getSearchParamsClient(searchParamsServer);

  return (
    <>
      {controls.map((item, i) => (
        <Badge
          onClick={() => handleDeleteBadge({ name: item.name, handleFiltersChanged, value: item.value })}
          key={`${item.text}_${i}`}
        >
          <FormattedText
            text={item.text}
            name={item.name}
            value={item.value || ''}
            localization={localization}
            searchParams={searchParams}
            dynamicFiltersResponse={dynamicFiltersResponse}
          />
          &nbsp;
          <CloseIcon />
        </Badge>
      ))}
    </>
  );
};

export default Badges;
